import EventDispatcherModule from '@shcc/modules/EventDispatcherModule';
import { customScrollModule } from '@shcc/modules/CustomScrollModule';
import { resizeModule } from '@shcc/modules/ResizeModule';

// Components
import { scrollContainerModule } from '@shcc/components/ScrollContainerComponent/ScrollContainerComponent';

// Helpers
import bindAll from '@shcc/utils/helpers/bindAll';
import fixed from '@shcc/utils/helpers/fixed';

function linearStep(x, min, max) {
  x = Math.max(min, x);
  x = Math.min(max, x);

  return (x - min) / (max - min);
}

function getProgress(offset, at) {
  return linearStep(at, offset.bottom, offset.top);
}

/**
 *
 * @todo: Lots of legacy code here
 *
 */

let frame = 0;
class CustomScrollTrackerModule extends EventDispatcherModule {
  constructor({ element, context, container }) {
    super();

    bindAll(this, ['_resizeHandler', '_customScrollUpdateHandler']);

    this.context = context || customScrollModule;
    this.container = container;
    this.element = element;
    this.progress = 0.0;
    this.visible = null;

    this.bounds = {};
    this.offset = {};

    this._setBounds();
    this._setOffset();
    this._setProgress();
    this._setVisibility();

    this._setupEventListeners();
  }

  resize() {
    this._setBounds();
    this._setOffset();
    this._setProgress();
    this._setVisibility();
  }

  destroy() {
    this._removeEventListeners();
  }

  _setupEventListeners() {
    if (this.container) {
      scrollContainerModule.addEventListener(
        `update:position:${this.container}`,
        this._customScrollUpdateHandler
      );
      scrollContainerModule.addEventListener(`restore`, this._resizeHandler);
    } else {
      this.context.addEventListener(
        'update:position',
        this._customScrollUpdateHandler
      );
    }

    resizeModule.addEventListener('resize', this._resizeHandler);
    resizeModule.addEventListener('resize:complete', this._resizeHandler);
  }

  _removeEventListeners() {
    if (this.container) {
      scrollContainerModule.removeEventListener(
        `update:position:${this.container}`,
        this._customScrollUpdateHandler
      );
      scrollContainerModule.removeEventListener(`restore`, this._resizeHandler);
    } else {
      this.context.removeEventListener(
        'update:position',
        this._customScrollUpdateHandler
      );
    }

    resizeModule.removeEventListener('resize', this._resizeHandler);
    resizeModule.removeEventListener('resize:complete', this._resizeHandler);
  }

  _setBounds() {
    this.bounds = this.element.getBoundingClientRect();
  }

  _setOffset() {
    const { viewportHeight } = resizeModule;
    const { height, top } = this.bounds;

    const y = this.container
      ? scrollContainerModule.get(this.container).position.y
      : this.context.position.y;

    this.offset.top = top + height + y;
    this.offset.bottom = top - viewportHeight + y;
  }

  _setProgress() {
    // console.log(frame % 2);
    const y = this.container
      ? scrollContainerModule.get(this.container).position.y
      : this.context.position.y;

    const progress = getProgress(this.offset, y);

    if (progress !== this.progress) {
      this.progress = progress;

      this.dispatchEvent('update:progress', { progress: this.progress });
      this.dispatchEvent('update', {
        progress: this.progress,
        visible: this.visible,
      });
    }
  }

  _setVisibility() {
    const visible = this.progress % 1 ? true : false;

    if (visible !== this.visible) {
      this.visible = visible;

      this.dispatchEvent('update:visibility', { visible: this.visible });
      this.dispatchEvent('update', {
        progress: this.progress,
        visible: this.visible,
      });
    }
  }

  /**
   *
   * Handlers
   */
  _resizeHandler() {
    this._setBounds();
    this._setOffset();
    this._setProgress();
    this._setVisibility();
  }

  _customScrollUpdateHandler(payload) {
    this._setProgress();
    this._setVisibility();
  }
}

export default CustomScrollTrackerModule;
